export default {
  title: 'Nom d\'utilisateur',
  informationsLabel: 'Nous vous recommandons d\'utiliser une adresse courriel en tant que nom d\'utilisateur.',
};
